import Axios from "axios";
import Vue from 'vue';

import getClientConfig from '@/util/clientConfig';
const clientConfig = getClientConfig(); 

const axios = Axios.create({
  baseURL: clientConfig.API_URL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json"
  }
});

axios.interceptors.request.use(config => {
  const token = localStorage.getItem("token");

  if (!token) {
    return config;
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// CURRENCY API
const currencyURL = "https://currency.cgtechnology.io";

const axiosCurrency = Axios.create({
  baseURL: currencyURL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json"
  }
});
axiosCurrency.interceptors.request.use(config => {
  const token = process.env.VUE_APP_TOKEN_CURRENCY;

  if (!token) {
    return config;
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const mockingURL = "http://mocking.test";

const axiosMocking = Axios.create({
  baseURL: mockingURL,
  headers: {
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    responseType: "json"
  }
});

export { axios, axiosCurrency, axiosMocking };
